import { DefaultService } from '@/services/DefaultService';

export default class FormGrupoPerguntaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    delete(id, contexto = "pro") {
        return this._http.delete(`${this._env}/${contexto}/formGrupoPergunta/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}